import React, { useEffect, useState } from "react";
import CodeList from "../../../lib/CodeList";
import { useTranslation } from 'react-i18next';

const codeList = new CodeList();

const solutions = [
  {
    key: "logiwork",
    titleKey: "tabSection.logiwork.title",
    sectionItem: (params) => <LogiWork {...params} />,
  },
  {
    key: "freiscop",
    titleKey: "tabSection.freiscop.title",
    sectionItem: (params) => <Freiscop {...params} />,
  },
  {
    key: "other",
    titleKey: "tabSection.other.title",
    sectionItem: (params) => <Other {...params} />,
  },
];

export default function TabSection(props) {
  const { isMobile, loginInfo } = props;
  const { t } = useTranslation();

  const scrollMove = (id) => {
    const targetOffsetTop = document.querySelector(`#${id}`).offsetTop - 20;
    window.scrollTo({ top: targetOffsetTop, behavior: "smooth" });
  };

  return (
    <div>
      <div>
        {solutions.map((item) => {
          return (
            <div key={item.key} id={item.key}>
              {item.sectionItem({
                isMobile: isMobile,
                loginInfo: loginInfo,
                scrollMove: scrollMove,
              })}
            </div>
          );
        })}
      </div>
    </div>
  );
}

function LogiWork({ isMobile, scrollMove }) {
  const { t } = useTranslation();
  return (
    <>
      <div className="d-flex flex-row flex-wrap justify-content-start justify-content-xl-between mb-2">
        <div className={`px-3 flex-grow-1`}>
          <p
            className={`${
              isMobile ? "h6" : "h5"
            } d-block border-bottom border-width-3 text-center p-3 font-weight-900 text-secondary cursor_pointer transition-1 border-freiscop text-freiscop`}
            onClick={() => {
              scrollMove("logiwork");
            }}
          >
            {t('tabSection.logiwork.title')}
          </p>
        </div>

        <div className={`px-3 flex-grow-1`}>
          <p
            className={`${
              isMobile ? "h6" : "h5"
            } d-block border-bottom border-width-3 text-center p-3 font-weight-900 text-secondary cursor_pointer transition-1`}
            onClick={() => {
              scrollMove("freiscop");
            }}
          >
            {t('tabSection.freiscop.title')}
          </p>
        </div>

        <div className={`px-3 flex-grow-1`}>
          <p
            className={`${
              isMobile ? "h6" : "h5"
            } d-block border-bottom border-width-3 text-center p-3 font-weight-900 text-secondary cursor_pointer transition-1`}
            onClick={() => {
              scrollMove("other");
            }}
          >
            {t('tabSection.other.title')}
          </p>
        </div>
      </div>
      <div className="row m-0 p-3 p-xl-5">
        <div className="col-12 col-xl-6 m-0 p-0">
          <div className="h-100 d-flex flex-column justify-content-between align-items-start">
            <p
              className={`${
                isMobile ? "" : "h6"
              } font-weight-bold m-0 d-inline-block px-2 py-xl-2 px-xl-4 bg-freiscop text-white`}
            >
              {t('tabSection.logiwork.estimate.title')}
            </p>
            <p
              className={` ${
                isMobile ? "h5" : "h2"
              } mb-0 mt-2 mb-1 my-xl-3 font-weight-900 text-dark`}
            >
              {t('tabSection.logiwork.estimate.description')}
            </p>
            <p
              className={`${
                isMobile ? "h6 mb-3" : "h5"
              } m-0 font-weight-bold text-secondary`}
            >
              {t('tabSection.logiwork.estimate.subDescription')}
            </p>
          </div>
        </div>
        <div className="col-12 col-xl-6 m-0 p-0">
          <div className="d-flex flex-row justify-content-center">
            <img height="auto" width="80%" src="/img/info/estimate.png" />
          </div>
        </div>
      </div>
      <div className="row m-0 p-3 p-xl-5 bg-light">
        <div className="col-12 col-xl-6 m-0 p-0">
          <div className="h-100 d-flex flex-column justify-content-between align-items-start">
            <p
              className={`${
                isMobile ? "" : "h6"
              } font-weight-bold m-0 d-inline-block px-2 py-xl-2 px-xl-4 bg-freiscop text-white`}
            >
              {t('tabSection.logiwork.cooperation.title')}
            </p>
            <p
              className={` ${
                isMobile ? "h5" : "h2"
              } mb-0 mt-2 mb-1 my-xl-3 font-weight-900 text-dark`}
            >
              {t('tabSection.logiwork.cooperation.description')}
            </p>
            <p
              className={`${
                isMobile ? "h6 mb-3" : "h5"
              } m-0 font-weight-bold text-secondary`}
            >
              {t('tabSection.logiwork.cooperation.subDescription')}
            </p>
          </div>
        </div>
        <div className="col-12 col-xl-6 m-0 p-0">
          <div className="d-flex flex-row justify-content-center">
            <img
              height="auto"
              width="80%"
              src="/img/info/cooperation_work.png"
            />
          </div>
        </div>
      </div>
      <div className="row m-0 p-3 p-xl-5">
        <div className="col-12 col-xl-6 m-0 p-0">
          <div className="h-100 d-flex flex-column justify-content-between align-items-start">
            <p
              className={`${
                isMobile ? "" : "h6"
              } font-weight-bold m-0 d-inline-block px-2 py-xl-2 px-xl-4 bg-freiscop text-white`}
            >
              {t('tabSection.logiwork.visualization.title')}
            </p>
            <p
              className={` ${
                isMobile ? "h5" : "h2"
              } mb-0 mt-2 mb-1 my-xl-3 font-weight-900 text-dark`}
            >
              {t('tabSection.logiwork.visualization.description')}
            </p>
            <p
              className={`${
                isMobile ? "h6 mb-3" : "h5"
              } m-0 font-weight-bold text-secondary`}
            >
              {t('tabSection.logiwork.visualization.subDescription')}
            </p>
          </div>
        </div>
        <div className="col-12 col-xl-6 m-0 p-0">
          <div className="d-flex flex-row justify-content-center">
            <img
              height="auto"
              width="80%"
              src="/img/info/visualization_freight.png"
            />
          </div>
        </div>
      </div>
      <div className="row m-0 p-3 p-xl-5 bg-light">
        <div className="col-12 col-xl-6 m-0 p-0">
          <div className="h-100 d-flex flex-column justify-content-between align-items-start">
            <p
              className={`${
                isMobile ? "" : "h6"
              } font-weight-bold m-0 d-inline-block px-2 py-xl-2 px-xl-4 bg-freiscop text-white`}
            >
              {t('tabSection.logiwork.document.title')}
            </p>
            <p
              className={` ${
                isMobile ? "h5" : "h2"
              } mb-0 mt-2 mb-1 my-xl-3 font-weight-900 text-dark`}
            >
              {t('tabSection.logiwork.document.description')}
            </p>
            <p
              className={`${
                isMobile ? "h6 mb-3" : "h5"
              } m-0 font-weight-bold text-secondary`}
            >
              {t('tabSection.logiwork.document.subDescription')}
            </p>
          </div>
        </div>
        <div className="col-12 col-xl-6 m-0 p-0">
          <div className="d-flex flex-row justify-content-center">
            <img height="auto" width="80%" src="/img/info/doc_manage.png" />
          </div>
        </div>
      </div>
      <div className="row m-0 p-3 p-xl-5">
        <div className="col-12 col-xl-5 m-0 p-0">
          <div className="h-100 d-flex flex-column justify-content-between align-items-start">
            <p
              className={`${
                isMobile ? "" : "h6"
              } font-weight-bold m-0 d-inline-block px-2 py-xl-2 px-xl-4 border border-freiscop text-freiscop`}
            >
              {t('tabSection.logiwork.fee.title')}
            </p>
            <p
              className={` ${
                isMobile ? "h5" : "h2"
              } mb-0 mt-2 mb-1 my-xl-3 font-weight-900 text-dark`}
            >
              {t('tabSection.logiwork.fee.description')}
            </p>
            <p
              className={`${
                isMobile ? "h6 mb-3" : "h5"
              } m-0 font-weight-bold text-secondary`}
            >
              {t('tabSection.logiwork.fee.subDescription')}
            </p>
            <div className="w-100 text-center text-xl-left">
              <button
                className="btn px-4 bg-freiscop text-white"
                onClick={() => {
                  window.open(
                    "http://home.gbts.co.kr/qa-join/",
                    "_blank",
                    "width=1200, height=800"
                  );
                }}
              >
                <i className="fa-regular fa-paper-plane mr-2" />
                {t('tabSection.logiwork.fee.inquiry')}
              </button>
            </div>
          </div>
        </div>
        <div className="col-12 col-xl-7 m-0 p-0 pl-xl-3">
          <div className="row m-0 py-3">
            <div className="col-12 col-sm-4 py-2 p-sm-2 p-xl-0 pr-xl-2">
              <div className="h-100 px-3 py-4 rounded-lg shadow d-flex flex-row flex-sm-column align-items-center">
                <div className="d-flex flex-column align-items-center text-center mr-2 mr-xl-0">
                  <p
                    className={`${isMobile ? "h6" : "h5"} mb-0 font-weight-900`}
                  >
                    {t('tabSection.logiwork.pricing.standard.title')}
                  </p>
                  <p
                    className={`${
                      isMobile ? "" : "h6 mb-0"
                    } text-secondary font-weight-bold`}
                  >
                    {t('tabSection.logiwork.pricing.standard.subtitle')}
                  </p>
                  <div className="w-50 border-bottom border-width-4 border-freiscop my-3" />
                  <p
                    className={`${
                      isMobile ? "h6" : "h5"
                    } font-weight-bold mb-2`}
                  >
                    {t('tabSection.logiwork.pricing.standard.price')}
                    <span className="font-size-05"> {t('tabSection.logiwork.pricing.vat')}</span>
                  </p>
                </div>
                <ul>
                  <li className="d-flex flex-row align-items-baseline mb-1 mb-xl-2">
                    <span
                      className="d-inline-flex flex-row align-items-center justify-content-center bg-freiscop text-white rounded-circle mr-1 font-size-06"
                      style={{ minWidth: 13, height: 13 }}
                    >
                      <i className="fa-solid fa-check" />
                    </span>
                    <p style={{ fontSize: "1.1em" }}>{t('tabSection.logiwork.pricing.standard.feature1')}</p>
                  </li>
                  <li className="d-flex flex-row align-items-baseline mb-1 mb-xl-2">
                    <span
                      className="d-inline-flex flex-row align-items-center justify-content-center bg-freiscop text-white rounded-circle mr-1 font-size-06"
                      style={{ minWidth: 13, height: 13 }}
                    >
                      <i className="fa-solid fa-check" />
                    </span>
                    <p style={{ fontSize: "1.1em" }}>
                      {t('tabSection.logiwork.pricing.standard.feature2')}
                    </p>
                  </li>
                  <li className="d-flex flex-row align-items-baseline mb-1 mb-xl-2">
                    <span
                      className="d-inline-flex flex-row align-items-center justify-content-center bg-freiscop text-white rounded-circle mr-1 font-size-06"
                      style={{ minWidth: 13, height: 13 }}
                    >
                      <i className="fa-solid fa-check" />
                    </span>
                    <p style={{ fontSize: "1.1em" }}>
                      {t('tabSection.logiwork.pricing.standard.feature3')}
                    </p>
                  </li>
                  <li className="d-flex flex-row">
                    <span
                      className="d-inline-flex flex-row align-items-center justify-content-center bg-freiscop text-white rounded-circle mr-1 font-size-06"
                      style={{ minWidth: 13, height: 13 }}
                    >
                      <i className="fa-solid fa-check" />
                    </span>
                    <p style={{ fontSize: "1.1em" }}>
                      {t('tabSection.logiwork.pricing.common')}
                    </p>
                  </li>
                </ul>
              </div>
            </div>
            <div className="col-12 col-sm-4 py-2 p-sm-2 p-xl-0 pr-xl-2">
              <div className="h-100 px-3 py-4 rounded-lg shadow d-flex flex-row flex-sm-column align-items-center">
                <div className="d-flex flex-column align-items-center text-center mr-2 mr-xl-0">
                  <p
                    className={`${isMobile ? "h6" : "h5"} mb-0 font-weight-900`}
                  >
                    {t('tabSection.logiwork.pricing.business.title')}
                  </p>
                  <p
                    className={`${
                      isMobile ? "" : "h6 mb-0"
                    } text-secondary font-weight-bold`}
                  >
                    {t('tabSection.logiwork.pricing.business.subtitle')}
                  </p>
                  <div className="w-50 border-bottom border-width-4 border-freiscop my-3" />
                  <p
                    className={`${
                      isMobile ? "h6" : "h5"
                    } font-weight-bold mb-2`}
                  >
                    {t('tabSection.logiwork.pricing.business.price')}
                    <span className="font-size-05"> {t('tabSection.logiwork.pricing.vat')}</span>
                  </p>
                </div>
                <ul>
                  <li className="d-flex flex-row align-items-baseline mb-1 mb-xl-2">
                    <span
                      className="d-inline-flex flex-row align-items-center justify-content-center bg-freiscop text-white rounded-circle mr-1 font-size-06"
                      style={{ minWidth: 13, height: 13 }}
                    >
                      <i className="fa-solid fa-check" />
                    </span>
                    <p style={{ fontSize: "1.1em" }}>{t('tabSection.logiwork.pricing.business.feature1')}</p>
                  </li>
                  <li className="d-flex flex-row align-items-baseline mb-1 mb-xl-2">
                    <span
                      className="d-inline-flex flex-row align-items-center justify-content-center bg-freiscop text-white rounded-circle mr-1 font-size-06"
                      style={{ minWidth: 13, height: 13 }}
                    >
                      <i className="fa-solid fa-check" />
                    </span>
                    <p style={{ fontSize: "1.1em" }}>
                      {t('tabSection.logiwork.pricing.business.feature2')}
                    </p>
                  </li>
                  <li className="d-flex flex-row align-items-baseline mb-1 mb-xl-2">
                    <span
                      className="d-inline-flex flex-row align-items-center justify-content-center bg-freiscop text-white rounded-circle mr-1 font-size-06"
                      style={{ minWidth: 13, height: 13 }}
                    >
                      <i className="fa-solid fa-check" />
                    </span>
                    <p style={{ fontSize: "1.1em" }}>
                      {t('tabSection.logiwork.pricing.business.feature3')}
                    </p>
                  </li>
                  <li className="d-flex flex-row">
                    <span
                      className="d-inline-flex flex-row align-items-center justify-content-center bg-freiscop text-white rounded-circle mr-1 font-size-06"
                      style={{ minWidth: 13, height: 13 }}
                    >
                      <i className="fa-solid fa-check" />
                    </span>
                    <p style={{ fontSize: "1.1em" }}>
                      {t('tabSection.logiwork.pricing.common')}
                    </p>
                  </li>
                </ul>
              </div>
            </div>
            <div className="col-12 col-sm-4 py-2 p-sm-2 p-xl-0 pr-xl-2">
              <div className="h-100 px-3 py-4 rounded-lg shadow d-flex flex-row flex-sm-column align-items-center">
                <div className="d-flex flex-column align-items-center text-center mr-2 mr-xl-0">
                  <p
                    className={`${isMobile ? "h6" : "h5"} mb-0 font-weight-900`}
                  >
                    {t('tabSection.logiwork.pricing.premium.title')}
                  </p>
                  <p
                    className={`${
                      isMobile ? "" : "h6 mb-0"
                    } text-secondary font-weight-bold`}
                  >
                    {t('tabSection.logiwork.pricing.premium.subtitle')}
                  </p>
                  <div className="w-50 border-bottom border-width-4 border-freiscop my-3" />
                  <p
                    className={`${
                      isMobile ? "h6" : "h5"
                    } font-weight-bold mb-2`}
                  >
                    {t('tabSection.logiwork.pricing.premium.price')}
                    <span className="font-size-05"> {t('tabSection.logiwork.pricing.vat')}</span>
                  </p>
                </div>
                <ul>
                  <li className="d-flex flex-row align-items-baseline mb-1 mb-xl-2">
                    <span
                      className="d-inline-flex flex-row align-items-center justify-content-center bg-freiscop text-white rounded-circle mr-1 font-size-06"
                      style={{ minWidth: 13, height: 13 }}
                    >
                      <i className="fa-solid fa-check" />
                    </span>
                    <p style={{ fontSize: "1.1em" }}>{t('tabSection.logiwork.pricing.premium.feature1')}</p>
                  </li>
                  <li className="d-flex flex-row align-items-baseline mb-1 mb-xl-2">
                    <span
                      className="d-inline-flex flex-row align-items-center justify-content-center bg-freiscop text-white rounded-circle mr-1 font-size-06"
                      style={{ minWidth: 13, height: 13 }}
                    >
                      <i className="fa-solid fa-check" />
                    </span>
                    <p style={{ fontSize: "1.1em" }}>
                      {t('tabSection.logiwork.pricing.premium.feature2')}
                    </p>
                  </li>
                  <li className="d-flex flex-row align-items-baseline mb-1 mb-xl-2">
                    <span
                      className="d-inline-flex flex-row align-items-center justify-content-center bg-freiscop text-white rounded-circle mr-1 font-size-06"
                      style={{ minWidth: 13, height: 13 }}
                    >
                      <i className="fa-solid fa-check" />
                    </span>
                    <p style={{ fontSize: "1.1em" }}>
                      {t('tabSection.logiwork.pricing.premium.feature3')}
                    </p>
                  </li>
                  <li className="d-flex flex-row">
                    <span
                      className="d-inline-flex flex-row align-items-center justify-content-center bg-freiscop text-white rounded-circle mr-1 font-size-06"
                      style={{ minWidth: 13, height: 13 }}
                    >
                      <i className="fa-solid fa-check" />
                    </span>
                    <p style={{ fontSize: "1.1em" }}>
                      {t('tabSection.logiwork.pricing.common')}
                    </p>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

function Freiscop({ isMobile, scrollMove }) {
  const { t } = useTranslation();
  return (
    <>
      <div className="d-flex flex-row flex-wrap justify-content-start justify-content-xl-between mb-2">
        <div className={`px-3 flex-grow-1`}>
          <p
            className={`${
              isMobile ? "h6" : "h5"
            } d-block border-bottom border-width-3 text-center p-3 font-weight-900 text-secondary cursor_pointer transition-1`}
            onClick={() => {
              scrollMove("logiwork");
            }}
          >
            {t('tabSection.logiwork.title')}
          </p>
        </div>

        <div className={`px-3 flex-grow-1`}>
          <p
            className={`${
              isMobile ? "h6" : "h5"
            } d-block border-bottom border-width-3 text-center p-3 font-weight-900 text-secondary cursor_pointer transition-1 border-freiscop text-freiscop`}
            onClick={() => {
              scrollMove("freiscop");
            }}
          >
            {t('tabSection.freiscop.title')}
          </p>
        </div>

        <div className={`px-3 flex-grow-1`}>
          <p
            className={`${
              isMobile ? "h6" : "h5"
            } d-block border-bottom border-width-3 text-center p-3 font-weight-900 text-secondary cursor_pointer transition-1`}
            onClick={() => {
              scrollMove("other");
            }}
          >
            {t('tabSection.other.title')}
          </p>
        </div>
      </div>
      <div className="row m-0 p-3 p-xl-5 bg-light">
        <div className="col-12 col-xl-5 m-0 p-0">
          <div className="h-100 d-flex flex-row justify-content-center align-items-center">
            <img
              height="auto"
              width="80%"
              src="/img/info/freiscop_.channel.png"
            />
          </div>
        </div>
        <div className="col-12 col-xl-7 m-0 p-0 order-first order-xl-last">
          <div className="h-100 d-flex flex-column justify-content-between align-items-start align-items-xl-end text-left text-xl-right">
            <p
              className={`${
                isMobile ? "" : "h6"
              } font-weight-bold m-0 d-inline-block px-2 py-xl-2 px-xl-4 bg-freiscop text-white`}
            >
              {t('tabSection.freiscop.singleChannel.title')}
            </p>
            <p
              className={` ${
                isMobile ? "h5" : "h2"
              } mb-0 mt-2 mb-1 my-xl-3 font-weight-900 text-dark`}
            >
              {t('tabSection.freiscop.singleChannel.description')}
            </p>
            <p
              className={`${
                isMobile ? "h6 mb-3" : "h5"
              } m-0 font-weight-bold text-secondary`}
            >
              {t('tabSection.freiscop.singleChannel.subDescription')}
            </p>
          </div>
        </div>
      </div>
      <div className="row m-0 p-3 p-xl-5">
        <div className="col-12 col-xl-5 m-0 p-0">
          <div className="d-flex flex-row justify-content-center">
            <img
              height={isMobile ? "400" : "250"}
              src="/img/info/e-book_note.png"
            />
          </div>
        </div>
        <div className="col-12 col-xl-7 m-0 p-0 text-right order-first order-xl-last">
          <div className="h-100 d-flex flex-column justify-content-between align-items-start align-items-xl-end text-left text-xl-right">
            <p
              className={`${
                isMobile ? "" : "h6"
              } font-weight-bold m-0 d-inline-block px-2 py-xl-2 px-xl-4 bg-freiscop text-white`}
            >
              {t('tabSection.freiscop.bookingUpdate.title')}
            </p>
            <p
              className={` ${
                isMobile ? "h5" : "h2"
              } mb-0 mt-2 mb-1 my-xl-3 font-weight-900 text-dark`}
            >
              {t('tabSection.freiscop.bookingUpdate.description')}
            </p>
            <p
              className={`${
                isMobile ? "h6 mb-3" : "h5"
              }  m-0 font-weight-bold text-secondary`}
            >
              {t('tabSection.freiscop.bookingUpdate.subDescription')}
            </p>
          </div>
        </div>
      </div>
    </>
  );
}

function Other({ isMobile, loginInfo, scrollMove }) {
  const { t } = useTranslation();
  return (
    <>
      <div className="d-flex flex-row flex-wrap justify-content-start justify-content-xl-between mb-2">
        <div className={`px-3 flex-grow-1`}>
          <p
            className={`${
              isMobile ? "h6" : "h5"
            } d-block border-bottom border-width-3 text-center p-3 font-weight-900 text-secondary cursor_pointer transition-1`}
            onClick={() => {
              scrollMove("logiwork");
            }}
          >
            {t('tabSection.logiwork.title')}
          </p>
        </div>

        <div className={`px-3 flex-grow-1`}>
          <p
            className={`${
              isMobile ? "h6" : "h5"
            } d-block border-bottom border-width-3 text-center p-3 font-weight-900 text-secondary cursor_pointer transition-1`}
            onClick={() => {
              scrollMove("freiscop");
            }}
          >
            {t('tabSection.freiscop.title')}
          </p>
        </div>

        <div className={`px-3 flex-grow-1`}>
          <p
            className={`${
              isMobile ? "h6" : "h5"
            } d-block border-bottom border-width-3 text-center p-3 font-weight-900 text-secondary cursor_pointer transition-1 border-freiscop text-freiscop`}
            onClick={() => {
              scrollMove("other");
            }}
          >
            {t('tabSection.other.title')}
          </p>
        </div>
      </div>
      <div>
        <div className="row m-0 p-3 pb-xl-5 bg-light">
          <div className="col-12 col-md-4 m-0 p-0">
            <div className="h-100 d-flex flex-column align-items-center justify-content-center">
              <h5 className="font-weight-bold">{t('tabSection.other.logiTalk.title')}</h5>
              <h3 className="font-weight-900 text-freiscop">
                {t('tabSection.other.logiTalk.name')}
              </h3>
              <img
                width="140px"
                className="my-3"
                src="img/info/logitalk_logo.png"
                alt="logiTalk"
              />
              <button
                className="btn px-4 bg-freiscop text-white"
                onClick={() => {
                  if (loginInfo === null) {
                    codeList.Modal.current.alert(
                      t('requestLoginMSG')
                    );
                    return;
                  } else {
                    window.open("/LogiTalk", "_blank", "width=1200 height=800");
                  }
                }}
              >
                <i className="fa-solid fa-arrow-right mr-2" />
                {t('tabSection.other.goTo')}
              </button>
            </div>
          </div>
          <div className="col-12 col-sm-6 col-md-4 m-0 py-3 p-xl-4">
            <div className="d-flex flex-row justify-content-center h-100">
              <div className="w-100 p-3 rounded-lg border shadow d-flex flex-column align-items-center bg-white">
                <img
                  src="/img/info/icon_phone.png"
                  alt="icon_phone"
                  className="mb-3"
                />
                <h5 className="font-weight-bold mb-2">{t('tabSection.other.smartphoneSync.title')}</h5>
                <div className="w-50 border-bottom mb-3" />
                <ul>
                  <li className="mb-2">
                    <div className="d-flex flex-row h6 m-0">
                      <span className="mr-2">·</span>{t('tabSection.other.smartphoneSync.desc1')}
                    </div>
                  </li>
                  <li className="mb-2">
                    <div className="d-flex flex-row h6 m-0">
                      <span className="mr-2">·</span>{t('tabSection.other.smartphoneSync.desc2')}
                    </div>
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <div className="col-12 col-sm-6 col-md-4 m-0 py-3 p-xl-4">
            <div className="d-flex flex-row justify-content-center h-100">
              <div className="w-100 p-3 rounded-lg border shadow d-flex flex-column align-items-center bg-white">
                <img
                  src="/img/info/icon_search.png"
                  alt="icon_search"
                  className="mb-3"
                />
                <h5 className="font-weight-bold mb-2">{t('tabSection.other.companySearch.title')}</h5>
                <div className="w-50 border-bottom mb-3" />
                <ul>
                  <li className="mb-2">
                    <div className="d-flex flex-row h6 m-0">
                      <span className="mr-2">·</span>{t('tabSection.other.companySearch.desc1')}
                    </div>
                  </li>
                  <li className="mb-2">
                    <div className="d-flex flex-row h6 m-0">
                      <span className="mr-2">·</span>{t('tabSection.other.companySearch.desc2')}
                    </div>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
        <div className="row m-0 p-3 pb-md-4 px-xl-0 py-xl-5">
          <div className="col-12 col-md-4 m-0 p-0">
            <div className="h-100 d-flex flex-column align-items-center justify-content-center">
              <h5 className="font-weight-bold">{t('tabSection.other.logiKeep.title')}</h5>
              <h3 className="font-weight-900 text-freiscop">
                {t('tabSection.other.logiKeep.name')}
              </h3>
              <img
                width="160px"
                className="my-3"
                src="/img/info/logikeep_icon.png"
                alt="logikeep"
              />
              <button
                className="btn px-4 bg-freiscop text-white"
                onClick={() => {
                  window.open("/storeMall", "_blank", "width=1200 height=800");
                }}
              >
                <i className="fa-solid fa-arrow-right mr-2" />
                {t('tabSection.other.goTo')}
              </button>
            </div>
          </div>
          <div className="d-none d-md-block col-12 col-md-4 m-0 p-0">
            <div className="h-100 d-flex flex-row align-items-center">
              <img
                height="auto"
                width="100%"
                src="/img/info/laptop_logikeep.png"
                alt="logikeep"
              />
            </div>
          </div>
          <div className="col-12 col-md-4 m-0 p-0 mt-5 mt-xl-0">
            <div className="h-100 px-3">
              <div className="h-50 d-flex flex-row align-items-end align-items-xl-center pr-4">
                <div className="bg-white h-80 px-3 py-4 position-relative border border-light shadow-sm mb-xl-4">
                  <div
                    className="py-2 px-4 bg-freiscop text-white position-absolute font-weight-bold"
                    style={{ top: "0", transform: "translateY(-50%)" }}
                  >
                    {t('tabSection.other.logiKeep.service')}
                  </div>
                  <p className="mt-2 h6 mb-0">
                    {t('tabSection.other.logiKeep.serviceDesc')}
                  </p>
                </div>
              </div>

              <div className="h-50 d-flex flex-row align-items-end align-items-xl-center pr-4">
                <div className="w-100 bg-white h-80 px-3 py-4 mt-5 mt-xl-0 position-relative border border-light shadow-sm">
                  <div
                    className="py-2 px-4 bg-freiscop text-white position-absolute font-weight-bold"
                    style={{ top: "0", transform: "translateY(-50%)" }}
                  >
                    {t('tabSection.other.logiKeep.process')}
                  </div>
                  <p className="mt-2 h6 mb-0">
                    {t('tabSection.other.logiKeep.processDesc')}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="p-5">
        <div className="row m-0 mb-xl-3 p-0">
          <div className="col-12 col-md-5 m-0 mb-3 mb-xl-0 p-0 pr-xl-3">
            <div className="h-100 d-flex flex-row justify-content-center justify-content-xl-end align-items-center">
              <div className="d-flex flex-column align-items-center">
                <img
                  className="mb-4"
                  src="/img/info/logitalk_logo.png"
                  width={isMobile ? "80" : "120"}
                  alt="logitalk_logo"
                />
                <div className={`${isMobile ? "h6" : "h3"} font-weight-bold`}>
                  <p>{t('tabSection.other.logiTalkTalk.title')}</p>
                </div>
                <p
                  className={`${
                    isMobile ? "h4" : "h2"
                  } font-weight-900 text-freiscop mb-3`}
                >
                  {t('tabSection.other.logiTalkTalk.name')}
                </p>
                <ul className="mb-3 px-2 px-xl-0">
                  <li>
                    <div className={`d-flex flex-row ${isMobile ? "" : "h6"}`}>
                      <i className="fa-solid fa-check mr-2 mt-1" />
                      <p>{t('tabSection.other.logiTalkTalk.feature1')}</p>
                    </div>
                  </li>
                  <li>
                    <div className={`d-flex flex-row ${isMobile ? "" : "h6"}`}>
                      <i className="fa-solid fa-check mr-2 mt-1" />
                      <p>
                        {t('tabSection.other.logiTalkTalk.feature2')}
                      </p>
                    </div>
                  </li>
                  <li>
                    <div className={`d-flex flex-row ${isMobile ? "" : "h6"}`}>
                      <i className="fa-solid fa-check mr-2 mt-1" />
                      <p>{t('tabSection.other.logiTalkTalk.feature3')}</p>
                    </div>
                  </li>
                </ul>
                <button
                  className="btn btn_1"
                  onClick={() => {
                    window.open(
                      "https://talktalk.gbts.co.kr/?site=GBTS",
                      "_blank",
                      "width=1200, height=800"
                    );
                  }}
                >
                  <p className="h6 m-0">
                    <i className="fa-solid fa-arrow-right mr-2" />
                    {t('tabSection.other.goTo')}
                  </p>
                </button>
              </div>
            </div>
          </div>
          <div className="col-12 col-md-7 m-0 p-0">
            <div className="d-flex flex-row justify-content-center align-items-end mx-3">
              {isMobile ? (
                <img
                  className="rounded-lg shadow mr-3"
                  width="60%"
                  src="/img/info/logiTalkTalk.png"
                  alt="logitalktalk"
                />
              ) : (
                <img
                  className="rounded-lg shadow mr-xl-5"
                  width="400px"
                  src="/img/info/logiTalkTalk.png"
                  alt="logitalktalk"
                />
              )}
              <img
                src="/img/info/employee_chat.png"
                alt="employee_chat"
                width="20%"
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
